
/**
 * Entry point for running the application.
 * Must export an object with a start() method.
 *
 * Since this is a feature, the entry point is only used for running it in isolation.
 * When consumed by a page, the entry point will be defined by the consumer.
 */
import $ from 'jquery';
import _ from 'lodash';
// import Backbone from 'backbone';
import Marionette from 'backbone.marionette';
import '@core/vendor/radio.shim'; // shim app.channel
import StoreLocator from '@component/int-store-locator';
// import customStoreList from './customStoreList';
import Example from './src/macys-new-stores';
import './src/scss/macys-new-stores.scss';
import pkg from './package.json';
import IntersectionObserver from "@core/util/intersection-observer"

window._ = _;
// window.IntersectionObserver = IntersectionObserver;
/* eslint-disable-next-line no-unused-vars,no-global-assign,no-undef,camelcase */
__webpack_public_path__ = `${pkg.version}/`;

const PageApp = new Marionette.Application();

PageApp.getMeta = () => null;

PageApp.on('start', () => {
  // if (Backbone.history) {
  PageApp.Feature = new Example();

  // scrollTo
  $('.scrollto').on('touchend click', (e) => {
    e.preventDefault();
    $('body,html').animate(
      {
        scrollTop: $('#cant-wait').offset().top - 50,
      },
      800, // speed
    );
  });
  $.get('//assets.mcomnyapps.net/market-by-macys/2022.7/feeds/storelist.json', (data) => {
    const storeLocator = new StoreLocator({
      horizontal: true, targetElem: 'store-locator-main', storeList: data.storelist, zipcode: data.zipcode,
    });
    console.log(storeLocator);
  });

  // const storeLocator = new StoreLocator({
  //   horizontal: true, targetElem: 'store-locator-main', storeList: customStoreList, zipcode: '76107',
  // });
  // console.log(storeLocator);


  const mainObject = $('#main');
  if (mainObject.length > 0) {
    PageApp.Feature.init();
  }
  // }
});

export default PageApp;




// WEBPACK FOOTER //
// /Users/michaelwheeler/Desktop/code/cmp_workspace/campaigns/macys-new-stores/app.js